import React from 'react';
import { Box, Container, Typography, Link as MuiLink, List, ListItem } from '@mui/material';
import { styled } from '@mui/system';

const FooterNav = styled(List)`
  display: flex;
  justify-content: center;
  padding: 0;
`;

const FooterNavItem = styled(ListItem)`
  width: auto;
  padding: 0 15px;
`;

function Footer() {
  return (
    <Box
      component="footer"
      bgcolor="lightgray"
      py={3}
      textAlign="center"
      sx={{
        width: '100%',
      }}
    >
      <Container>
        <Typography variant="body2" color="textSecondary">
          © {new Date().getFullYear()} CoinStatsHub.tech. All rights reserved.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Service provided by{' '}
          <MuiLink href="https://fuertecoin.network/" target="_blank" rel="noopener noreferrer" color="inherit">
            FuerteCoin
          </MuiLink>
        </Typography>
        <FooterNav>
          <FooterNavItem>
            <MuiLink href="/about" color="inherit" underline="none">
              About
            </MuiLink>
          </FooterNavItem>
          <FooterNavItem>
            <MuiLink href="/privacy" color="inherit" underline="none">
              Privacy Policy
            </MuiLink>
          </FooterNavItem>
          <FooterNavItem>
            <MuiLink href="/terms" color="inherit" underline="none">
              Terms of Service
            </MuiLink>
          </FooterNavItem>
        </FooterNav>
      </Container>
    </Box>
  );
}

export default Footer;
